<script lang="ts" setup>
import emitter from "@/utils/mitt";
import { onBeforeMount, watch } from "vue";
import { useI18n } from "vue-i18n";
import { setDefaultFailToastOptions } from "@/stores/loading";
import { loadLocaleMessage } from "@/locales";

const { t, locale } = useI18n();

// 监听 locale 动态加载语言包
watch(locale, async (newVal) => {
  await loadLocaleMessage(newVal);
});

setDefaultFailToastOptions({
  message: t("frequentOperationsTryLater")
});

onBeforeMount(() => {
  window.onReady = () => {
    console.log("onReady");
  };
  window.onShow = () => {
    console.log("onShow");
    emitter.emit("lifeOnShow");
  };
  window.onHide = () => {
    console.log("onHide");
    emitter.emit("lifeOnHide");
  };
  window.onUnload = () => {
    emitter.emit("onUnloadLife");
    console.log("onUnload");
    localStorage.removeItem("skipToGuide");
  };
});
</script>

<template>
  <RouterView v-slot="{ Component }">
    <Component :is="Component"></Component>
  </RouterView>
</template>

<style>
html,
body,
#app {
  overscroll-behavior: none;
}
</style>
